import { SiteLayoutComponent, SiteSection } from 'shared/components/site-layout';
import { prerenderMarkLoaded } from "shared/mechanics/prerender";

import { AuthSignInLayout } from "./layout";

export const AuthSignInPage = () => {
	prerenderMarkLoaded();

	return (
		<SiteLayoutComponent activeSection={SiteSection.None}>
			<AuthSignInLayout />
		</SiteLayoutComponent>
	);
}